import {compose} from 'recompose';
import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import L from 'leaflet';
import 'leaflet.markercluster/dist/leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import {useLeaflet} from 'react-leaflet';

const TemplateStopTemplateStopMarkerCluster = React.memo((props) => {

  const {
    templateStops,
    t,
    getClusterIcon,
    getTemplateStopMarkerAndAddToMcg,
    useCluster,
    clusterIconColor,
  } = props;

  const mcg = L.markerClusterGroup({
    iconCreateFunction: function () {
      return getClusterIcon(clusterIconColor);
    },
    maxClusterRadius: 50,
    showCoverageOnHover: false,
    disableClusteringAtZoom: useCluster ? 16 : 1,
    spiderfyOnMaxZoom: false
  });


  const {map} = useLeaflet();

  useEffect(() => {
    mcg.clearLayers();
    templateStops.forEach(templateStop => getTemplateStopMarkerAndAddToMcg(templateStop, mcg, t));
    map.addLayer(mcg);
    return function cleanup() {
      map.removeLayer(mcg);
    }
  }, [templateStops, t, mcg, map, getTemplateStopMarkerAndAddToMcg]);

  return null;
});

TemplateStopTemplateStopMarkerCluster.propTypes = {
  clusterIconColor: PropTypes.string,
  getClusterIcon: PropTypes.func.isRequired,
  getTemplateStopMarkerAndAddToMcg: PropTypes.func.isRequired,
  templateStops: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  useCluster: PropTypes.bool.isRequired
};

export default compose(withTranslation())(TemplateStopTemplateStopMarkerCluster);
